import React from "react";
import { Col, Container, Row } from "reactstrap";
import SEO from "src/components/General/SEO";
// tslint:disable:max-line-length
const CourseFAQ: React.FunctionComponent = () => {
  return (
    <Container className="mt-2 faq">
      <SEO
        title={"Psychedelic Support Courses FAQ"}
        description={"Psychedelic Support provides accredited online education for psychedelics."}
        pathname="/education/course-faq/"
      />
      <Row>
        <Col>
          <h3>Course FAQ</h3>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <h6>Are there prerequisites?&nbsp;</h6>
          <p>No. Anyone may take these courses.&nbsp;</p>
          <h6>What’s included?</h6>
          <ul>
            <li>Option for continuing education (CME/CE)&nbsp;</li>
            <li>Interactive eLearning modules with narration</li>
            <li>Interviews with psychedelic therapists, medical doctors, researchers, and neuroscientists</li>
            <li>Animations and detailed graphics of complex topics</li>
            <li>Conversations with therapists and academic researchers around special topics</li>
            <li>Discussion forum to engage with other learners and instructors</li>
            <li>Knowledge checks throughout the course&nbsp;</li>
            <li>Assignments to further advancement your knowledge and comprehension&nbsp;</li>
            <li>Downloadable reference lists with cited publications and links</li>
            <li>Downloadable resources documents with suggested videos, books, articles, and websites</li>
            <li>1-year access to our online learning platform</li>
            <li>Official Psychedelic Support Certificate of Completion and CE/CME Certificates (optional)</li>
          </ul>
          <h6>What is the difference between the courses for learners, CE, and CME?</h6>
          <p>
            The course content is the same for learners and CE/CME except that purchase of CE/CME course gets continuing
            education credits for professionals.
          </p>
          <h6>Can I take the course online?</h6>
          <p>
            Our global courses are only offered online and may be accessed from anywhere in the world. Use a computer or
            tablet for the best learning experience.&nbsp;
          </p>
          <h6>Who should take this program? What will it do for me?</h6>
          <p>
            Teachings are appropriate for healthcare professionals, researchers, students, as well as the general
            public. Healthcare professionals will be able to incorporate the information offered in this program in ways
            beneficial to clients or patients. Having a strong foundation in understanding risks of psychedelic use in
            clinical and non-medical settings, research findings, and contraindicated medications and diagnoses will
            enable you to communicate effectively with your clients. This program is not intended to prepare providers
            to deliver psychedelic-assisted therapy, which is currently not legal in the USA and most other
            countries.&nbsp;
          </p>
          <h6>How much does the course cost?</h6>
          <p>
            We offer different course prices for mental health professionals, medical doctors, and students/general
            public. Make sure you select the correct option when you checkout.&nbsp;The continuing education (CE/CME)
            courses offer credits for health professionals.
          </p>
          <h6>How long will it take me to complete the course?&nbsp;</h6>
          <p>
            Courses contain a variety of interactive modules, expert interviews, and quizzes. See each course
            description for the amount of time to complete each course. You will have access to the course in our online
            learning platform for 1 year.
          </p>
          <h6>Do I have to pass the course?&nbsp;</h6>
          <p>
            You will be required to complete the final exams at the end of each module. After you finish the course, you
            will receive an official Psychedelic Support Certificate of Completion. If you choose the CE/CME option, you
            will additionally receive a Certificate of Attendance after completing all activities and the required
            survey.&nbsp;
          </p>
          <h6>What if I’m not satisfied with the course?</h6>
          <p>
            Psychedelic Support offers best in class educational content. If you’re not satisfied, we’re not satisfied!
            Psychedelic Support offers a money back guarantee on educational content (excluding card processing fee and
            LMS registration). Offer not valid if course certificate has been issued.&nbsp;
          </p>
          <h6>Do I need any materials for the course?</h6>
          <p>
            Other than internet access, just a learning mind! No hard materials or books are required for the course and
            you’ll be able to access reference materials, videos and modules from within your account. Login in
            anywhere, anytime.&nbsp;
          </p>
          <h6>How long can I access the course?</h6>
          <p>You will have access to the course for 1 year from the date of purchase.</p>
          <h6>Is this course intended to give medical advice?&nbsp;</h6>
          <p>
            No, this course is for educational purposes and is not meant to serve in place of medical treatment. Should
            you have further questions or concerns about receiving treatment, please refer to our resources page for
            referral information. Always seek the advice of your physician or other qualified healthcare provider with
            any questions you may have regarding a medical condition. Never disregard professional medical advice or
            delay in seeking treatment because of something you have read in this course.&nbsp;
          </p>
          <p>
            Psychedelic Support does not endorse the use of illegal substances or deferring from local, state, and
            federal laws. We recognize the necessity for empathetic care, harm reduction strategies, and evidence-based
            education.&nbsp;
          </p>
          <h6>Will this course teach me to administer psychedelic psychotherapy?</h6>
          <p>
            Our courses are based on the latest peer reviewed research in the field of psychedelic science.
            Professionals will gain a strong knowledge base and be equipped to answer questions from clients about
            safety, therapeutic approaches, and clinical trial outcomes. However, our courses do not provide instruction
            on administering psychedelic psychotherapy and do not qualify one to administer this type of therapy to
            clients which is currently not legal outside of clinical trials.&nbsp;
          </p>
          <h6>I already purchased a course. How do I login to the online learning platform?</h6>
          <p>
            You can login through{" "}
            <a href="https://psychedelicsupport.talentlms.com/" target="_blank" rel="noreferrer nofollow noopener">
              this link
            </a>{" "}
            after purchasing a course.{" "}
          </p>
          <div className="mt-5">
            Still need to speak to us?&nbsp; Email us at{" "}
            <a href="mailto:info@psychedelic.support">info@psychedelic.support</a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CourseFAQ;
